import apiClient, { handleApiResponse, handleApiError } from './apiClient';

/**
 * Chatbot Service
 * Handles communication with the backend chatbot API
 */
class ChatbotService {
  /**
   * Send a message to the chatbot and get a response
   * @param {string} message - User's message
   * @param {Array} conversationHistory - Previous conversation messages
   * @returns {Promise<string>} Chatbot response
   */
  async sendMessage(message, conversationHistory = []) {
    try {
      const response = await apiClient.post('/public/chatbot', {
        message: message,
        conversation_history: conversationHistory
      });
      return handleApiResponse(response).response;
    } catch (error) {
      handleApiError(error);
    }
  }
}

export default new ChatbotService();